import { INIT_CARTO, LOAD_MAP, LOAD_LAYER, RESET_LAYERS, APPLY_FILTER, ADD_POPUP, CLEAR_FILTERS, LOAD_DATAVIEW } from '../actions/types'

const initialState = {
    carto: false,
    map: false,
    layers: {},
    dataviews: {},
}

export default function(state = initialState, action) {
    switch(action.type) {
        case INIT_CARTO:
            return {
                ...state,
                carto: true
            }

        case LOAD_MAP:
            return {
                ...state,
                map: true
            }

        case LOAD_LAYER:
            state.layers[action.payload.name] = action.payload
            return state

        case LOAD_DATAVIEW:
            state.dataviews[action.payload.name] = action.payload
            return state

        case RESET_LAYERS:
            return {
                ...state,
                layers: {}
            }

        case APPLY_FILTER:
            let layer = state.layers[action.payload.layerName] || state.dataviews[action.payload.layerName]
            layer.filters = action.payload.filters
            layer.filterLabels = action.payload.filterLabels
            return state

        case ADD_POPUP:
            state.layers[action.payload.layerName].popup = { eventName: action.payload.eventName, popupContent: action.payload.popupContent }
            return state

        case CLEAR_FILTERS:
            let layer2 = state.layers[action.payload.layerName] || state.dataviews[action.payload.layerName]
            Object.keys(layer2.filters).forEach(filter => delete layer2.filters[filter])
            return state
        
        default:
            return state;
    }
}